import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
//import FlexView from "react-flexview";
import DataGrid from "../../../../../../shared/Components/Grid";
import {exportGrid, initialColsSelector, onChangeColumns} from "../../../../../../shared/Components/Grid/functions";
import { getColumnDefs } from "./columnDefs";

export interface Props {
  data: any;
  ref: any;
  style?: any;
  menu: boolean;
  selector: boolean;
  onSelected?(selected: any): any;
	onChange?(row: any): any;
}

export const GridResultsScreen = forwardRef((props:Props, ref:any) => {

  let { data, style, menu, selector, onSelected, onChange} = props;
  let columnDefs = getColumnDefs();
  let [columnsState, SetColumnsState] = useState(selector?initialColsSelector(columnDefs):[])
  let [api, setApi] = useState(undefined)

  useEffect(()=>{
    onRowSelection(api)
  },[data])

  const onSelection = (api: any, selected: any) => {
		onSelected && onSelected(selected);
  };

  const onRowValueChanged = (api: any, event: any) => {
		onChange && onChange(event.data);
  };
  
  const onHideColumn = (newColumns:[any]) =>{
    let newState = onChangeColumns(newColumns, columnDefs);
    SetColumnsState(newState)
  }

  const onRowSelection = (api:any) =>{
    let data = api && api.getSelectedNodes();
    if(data)
    {
      data = data.filter((f:any) => f.isSelected()===true)
      onSelected && onSelected(data.map((d:any)=> d.data));
    }
  }

  useImperativeHandle(
    ref,
    () => ({
        onExport() {
            api && exportGrid({ fileName: "Usuarios", api: api })
        }
     })
  )

  const updateApi = (api:any) =>{
    setApi(api)
  }

    return (
      // <FlexView grow column>
        <DataGrid
        data={data}
        columnDefs={columnDefs}
        columnsState={columnsState}
        menu={menu}
        selector={selector}
        floatingFilter
        fileExportName="usuarios"
        onHideColumn = {onHideColumn}
        onSelectionChanged={onSelection}
        onRowSelected={onRowSelection}
        onRowValueChanged={onRowValueChanged}
        updateApi={updateApi}
        />
      // </FlexView>
    );
});